export type DocumentPreviewKind = 'pdf' | 'image' | 'docx' | 'heic' | 'unsupported';

export function fileExtension(fileName: string): string {
    const base = fileName.trim().split(/[/\\]/).pop() || '';
    const dot = base.lastIndexOf('.');
    if (dot < 0 || dot === base.length - 1) {
        return '';
    }
    return base.slice(dot + 1).toLowerCase();
}

export function documentPreviewKind(fileName: string): DocumentPreviewKind {
    switch (fileExtension(fileName)) {
        case 'pdf':
            return 'pdf';
        case 'jpg':
        case 'jpeg':
        case 'png':
            return 'image';
        case 'docx':
            return 'docx';
        case 'heic':
        case 'heif':
            return 'heic';
        default:
            return 'unsupported';
    }
}

export function imageMimeType(fileName: string): string {
    return fileExtension(fileName) === 'png' ? 'image/png' : 'image/jpeg';
}
